import logo from "./logo.svg";
import "./App.css";
import { Box } from "@chakra-ui/react";
import MainRoutes from "./components/Routes/MainRoutes";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { mixpanelAppRegister, mixpanelPathnameEvent } from "./components/utils/mixpanelFunctions";
import { useLocation } from "react-router-dom";

function App() {
  const { isAuth,user } = useSelector((state) => state.auth);
  const pageLocation = useLocation();
  const { pathname } = pageLocation;

  useEffect(()=>{
   if(isAuth){
    mixpanelAppRegister(user?.email,user?.role)
   }
  },[isAuth])

  useEffect(()=>{
     mixpanelPathnameEvent(pathname)  // track url
  },[pathname])

  return (
    <Box>
      <MainRoutes />
    </Box>
  );
}

export default App;
